import { atom } from 'recoil';

// Define a Recoil atom for coach mark states
export const coachMarkState = atom<Record<string, boolean>>({
  key: 'coachMarkState', // unique ID (with respect to other atoms/selectors)
  default: {} // default state
});
